<template>
  <div class="list">
    <div class="text">
      <nuxt-link
        class="flex"
        to="/influencer/cashout/"
        @click.native="$emit('close')"
      >
        <span>{{ $t("layout.navigation08") }}</span>
        <div class="quickFlex">
          <span class="amount">{{ grooviz }}</span>
          <img class="grooviesIcon" src="/media/grooviz_light_grey.svg" />
        </div>
      </nuxt-link>
    </div>
    <div class="text">
      <nuxt-link to="/influencer/dashboard/" @click.native="$emit('close')">
        {{ $t("layout.navigation03") }}
      </nuxt-link>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      grooviz: (state) => state.user.grooviz,
    }),
  },
}
</script>
<style scoped>
b {
  font-weight: 500;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.amount {
  color: var(--color-darker-grey);
  font-size: var(--font-size-small);
  font-weight: 500;
}

.grooviesIcon {
  margin-left: 4px;
  width: 16px;
  height: 16px;
}
</style>
<style scoped src="./shared.css"></style>
